module.exports = __webpack_public_path__ + "static/media/Tv.9922e786.png";